import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import { CloseDialogButton } from '~/components/CloseDialogButton';
import { ResponseError } from '~/domain/ResponseError';

import { GenericErrorMessage } from './GenericErrorMessage';

interface IGenericErrorDialog {
  error: Error | ResponseError;
  onClose?: () => void;
}

export const GenericErrorDialog: React.FC<IGenericErrorDialog> = (props) => {
  const { error, onClose } = props;
  const handleCancel = (e?: React.MouseEvent) => {
    e?.stopPropagation();
    if (onClose) {
      onClose();
    }
  };
  return (
    <Dialog
      open
      onClose={(e, reason) => {
        reason === 'escapeKeyDown' && handleCancel(e as React.MouseEvent);
      }}
    >
      <DialogTitle>
        <CloseDialogButton onClick={handleCancel} />
      </DialogTitle>
      <DialogContent>
        <GenericErrorMessage error={error} />
      </DialogContent>
    </Dialog>
  );
};
